/**
 * Created by Zac on 22/02/2016.
 */

// import jQuery from "jquery";/
// import jQuery from 'jquery';
// require('jquery-ui');  //Is needed for some of the plugins
// require('bootstrap');     //Being consitent
import Tether from 'tether';
import Debug from 'debug';
import inView from 'in-view';
// import jQuery from 'jQuery';
const debug = Debug('gh:lobuilder:tabs');
let workedExampleTriggerTether = null;
const workedExampleTriggerTetherjQuery = null;
// +function ($) {


/*
The expected format is like
<div class="js__tabs">
    <div class="js__tabs__tab-link-container">    <!-- not strictly needed -->
        <div class="js__tabs__tab-link js__tabs--active" data-target="" href="">
        </div>
    </div>
</div>
<div>
    <div class="js__tabs__tab-pane"></div>
    <div class="js__tabs__tab-pane">
        <button class="js__tabs__tab-trigger--fixed-bottom">Sits at the bottom of the screen</button>
    </div>
</div>

<button class="js__tabs__to-tab" href="#SomeTab" data-target="#SomeTab">Link to a tab</button>
*/
// / TODO: Old classes that need to be removed js__children__tabs__tab js__tabs__tab
$(() => {
  // since the above is not working, just go to the first scene...
//     /** add events for the page tabs */
//     $('#Sections a').click(function (e) {
//         e.preventDefault();
//         $(this).tab('show');
//   })


//   // toggle images on unit page navigation
//   $('#taskimagetoggle').click(function(){
//       img = $('#taskimg').attr("src");
//       if (img.indexOf("_white")>0) {
//           img = img.replace("_white","_blue");
//       } else {
//           img = img.replace("_blue","_white");
//       }
//       $('#taskimg').attr("src",img);
//   });

//         $('#Sections a:first').show();
//         $('#Sections a:first').tab('show');

//     const tabWrangler = function (x) {
//         if (x != undefined && x.indexOf('#') > 0) {
//             $(`#Sections a[href="${x}"]`).tab('show');
//                 // $('.modal').modal('hide');
//         }
//     };

//     // set up anchor tags to open a particular tab (e.g. Citation or Report) if required
//     $('#myTabContent a').click(function (event) {
//         tabWrangler($(this).attr('href'));
//         // console.log("$(this).attr('href'): "+$(this).attr('href'));
//     });
//     // set up anchor tags on sub menu (eg in unit type pages) to open a particular tab (e.g. Citation or Report) if required
//     $('#myTabContent2 a').click(function (event) {
//         tabWrangler($(this).attr('href'));
//         // console.log("$(this).attr('href'): "+$(this).attr('href'));
//     });

//     // save the active tab
//     let activeTab = null;

//     if (window.location.hash) {
//         activeTab = window.location.hash;
//     }

//     // open the first tab to start off with if none is specified in the url (eg #Content)
//     // if ($('#Sections').length > 0) {
//     //     if (!activeTab) {
//     //         // $('#Sections a:first').click();
//     //     } else {
//     //         $(`#Sections a[href*="${activeTab}"]`).click();
//     //     }
//     // }
//     $('#Sections a[data-toggle="tab"]').on('shown', (e) => {
//         activeTab = e.target.pathname + e.target.hash;
//         // console.log('activeTab: '+activeTab);
//         window.location.hash = e.target.hash.substring(1); // update the address bar so we can use the back button
//         if (e.target.hash === '#Content' || e.target.hash === '#Citation' || e.target.hash === '#Report' || e.target.hash === '#AUReport' || e.target.hash === '#workedExample' || e.target.hash === '#FERs') {
//             $('#progressbar').show();
//         } else {
//             $('#progressbar').hide();
//         }
//     });


//     function hideEntryandHighlightCurrent(here) {
//         $(here).find('.active  img').show();           // The currently focused one
//         $(here).find('.inactive  img').hide();

//         // $('.subnav li[data-active="1"] .active img').hide();          // The newly selected one
//         // $('.subnav li[data-active="1"] .inactive img').show();
//     }

//     function showEntryandunHightlighOld(here) {
//         $(here).find('.active  img').hide();
//         $(here).find('.inactive  img').show();

//         $('.subnav li[data-active="1"] .active img').show();          // The newly selected one
//         $('.subnav li[data-active="1"] .inactive img').hide();
//     }

//     function checkIfAnotherChildTab(base) {
//         const newTabLink = base.find(' > div > div > div > div > div > div > .gh-tabs > .tab.active');
//         const nextTabLink = newTabLink.next();
//         return nextTabLink.length > 0;
//     }

//     $('body').on('easytabs:after', (event) => {
//         // console.log(event);
//         //  var newTabLink = $(event.target).find('.tab.active');
//         //  var nextTabLink = newTabLink.next();
//         //  console.log(nextTabLink);
//         if (!checkIfAnotherChildTab($(event.target))) {
//             if (DEBUGGING)console.log($(event.target).closest('.tab-content').find('[data-target="next-tab"]'));
//             $(event.target).closest('.tab-content').find('[data-target="next-tab"]').show();
//         }
//     });

//     /*
//         When a new tab is shown
//             Check if there is another tab that needs to be show
//                 if there is ensure the next button is shown
//                 otherwise hide the next button

//         '.js__tabs').on('shown.bs.tab' Triggered on 
//             - Worked example pages on iponz-socrates
//             - add more as needed
//     */

//     $('.js__tabs').on('shown.bs.tab', (event, ...args) => {
//         const tabLinks = $(event.currentTarget).children('.js__tabs__tab');
//         const currentTabLink = $(event.target);
//         const isLastTab = currentTabLink.is(':last-child');

//         const dataTargetRef = $(event.target).attr('data-target');
//         const hrefExtract = /#(.+)/.exec($(event.target).attr('href'));
//         const href = (hrefExtract.length > 1 ? hrefExtract[1] : null);
//         const newTabSelector = ((dataTargetRef || href) ? `#${dataTargetRef || href}` : null);
//         const newTab = $(newTabSelector);
//         debug('isLastTab', isLastTab);
//         if (isLastTab) {
//             debug('Hidding the next tab button');
//             newTab.find('.row > [data-target="next-tab"]').hide();
//         } else {
//             debug('Ensuring the next tab button is showing');
//             newTab.find('.row > [data-target="next-tab"]').show();
//         }

//         // Handle the specific worked example buttons
//         const workedExampleTrigger = newTab.find('.gh__WorkedExample__end-next-section-trigger');
//         if (workedExampleTrigger.length > 0){
//             debug('Attaching worked example end trigger');
//             if (workedExampleTriggerTether) workedExampleTriggerTether = new Tether({
//                 element: workedExampleTrigger.first(),
//                 target: 'body',
//                 attachment: 'bottom middle',
//                 targetAttachment: 'bottom middle'
//               });
//         }
//     });

//     $('.js__tabs').on('hide.bs.tab', (event) => {
//         const currentTab = $(event.currentTarget).children('.js__tabs__tab.active');
//         // Handle the specific worked example buttons
//         const workedExampleTrigger = currentTab.find('.gh__WorkedExample__end-next-section-trigger');
//         if (workedExampleTrigger.length > 0) {
//             debug('Detaching worked example end trigger');

//             workedExampleTriggerTether.release();
//         }
//     });

//     function updateNextTabButtons() {

//     }


//     $('.subnav > ul > li > a').on('show.bs.tab', (e) => {
//         window.location.hash = e.target.hash;

//         $('.subnav li[data-active="1"] .active img').hide();          // The newly selected one
//         $('.subnav li[data-active="1"] .inactive img').show();

//         $('.subnav li[data-active="1"]').removeClass('active');
//         $('.subnav li[data-active="1"]').attr('data-active', 0);


//         $(e.target).parent().attr('data-active', 1);
//         $(e.target).parent().addClass('active');
//     });

//     $('.subnav > ul > li.active .active > img').each(function (index) {
//         $(this).show();             // Shows the image for the currently selected tab
//     });
//     $('.subnav > ul > li:not(.active) .inactive > img').each(function (index) {
//         $(this).show();                 // Shows the image for all the non selected tab
//     });


//     const href = document.location.toString();

//     if (href.match('#')) {
//         const currentpage = href.split('#')[1];

//         if ($(`.subnav a[href*="#${currentpage}"]`).length > 0) {
//             debug('tab is', $(`.subnav a[href*="#${currentpage}"]`));

//             $(`.subnav a[href*="#${currentpage}"]`).click();

//             $('.subnav li[data-active="1"] .active img').hide();          // The newly selected one
//             $('.subnav li[data-active="1"] .inactive img').show();

//             hideEntryandHighlightCurrent(`li[data-target="${currentpage}"]`);

//             $('.subnav li[data-active="1"]').removeClass('active');
//             $('.subnav li[data-active="1"]').attr('data-active', 0);


//             $(`li[data-target="${currentpage}"]`).attr('data-active', 1);
//             $(`li[data-target="${currentpage}"]`).addClass('active');
//         }
//     }

//     $('.subnav > ul > li').hover(function (e) {   // Triggered on the start
//         hideEntryandHighlightCurrent(this);
//     }, function (e) {                    // Trigger on leaving
//         showEntryandunHightlighOld(this);
//     });


//     if ($('.subnav').length > 0) {
//         $('.subnav').affix({
//             offset: {
//                 top: $('.subnav').offset().top,
//             },
//         });
//     }


//     // Vertical tabs
     $('.js__sequence_page--vertical_tabs__list__item').click((e) => {
         // const linkIndex = ($(e.currentTarget).parentsUntil('.gh__sequence__page--vertical_tabs__container__list').parent()).index(e.currentTarget);
         const linkIndex = $(e.currentTarget).index();

         const parent = $(e.currentTarget).parentsUntil('.js__sequence_page--vertical_tabs').parent();
         const linksContainer = $(parent).children('.js__sequence_page--vertical_tabs__list');
         const links = $(linksContainer).children('.js__sequence_page--vertical_tabs__list__item');
         const tabPaneContainer = $(parent).children('.js__sequence_page--vertical_tabs__panes');
         const tabPanes = $(tabPaneContainer).children('.js__sequence_page--vertical_tabs__panes__pane');
         debug('Tab index to show is', linkIndex);
         $(tabPanes).each((index, el) => {
             // const index = $(this).index();
             if (index == linkIndex) {
                 debug('Showing tab index', index);
                 $(el).addClass('gh__sequence__page--vertical_tabs__container__tabs__pane--active');
                 $(el).removeClass('gh__sequence__page--vertical_tabs__container__tabs__pane--not-active');
             } else {
                 debug('Hiding tab index', index);
                 $(el).removeClass('gh__sequence__page--vertical_tabs__container__tabs__pane--active');
                 $(el).addClass('gh__sequence__page--vertical_tabs__container__tabs__pane--not-active');
             }
         });
         $(links).each((index, el) => {
            // const index = $(this).index();
             if (index == linkIndex) {
                 debug('Setting tab link active, index', index);
                 $(el).addClass('gh__sequence__page--vertical_tabs__container__list__item--active');
                 $(el).removeClass('gh__sequence__page--vertical_tabs__container__list__item--not-active');
             } else {
                 debug('Setting tab link inactive, index', index);
                 $(el).removeClass('gh__sequence__page--vertical_tabs__container__list__item--active');
                 $(el).addClass('gh__sequence__page--vertical_tabs__container__list__item--not-active');
             }
         });
    });

  // TODO: Need to trigger a click for the first tab on load
  function ensureTopOfTabShown(tabLink, tabPane) {
    const linkVisible = inView.is(tabLink[0]);
    const tabPaneVisible = inView.is(tabPane[0]);

    if (!linkVisible) {
      let offset;
      if (tabPane.closest('.subnav') && tabPane.closest('.subnav').hasClass('affix')) {
        offset = 0; // Need to hardcode it on TMET unit pages as it uses the floating bar
      } else {
        offset = Math.abs(tabPane.offset().top - 40); // There is an extra offset due to the fixed toolbar on TMET
      }
      debug('Tab offset is', offset);
      // scroll to the top of the tap before switching tabs
      $('html, body').animate({ // TODO: only if not in view and only if the tab has changed
        scrollTop: `${offset}px`,
      }, 0);
    }
  }

  function workedExampleBeforeShown(toTabPane) {
    if (workedExampleTriggerTether) {
      debug('Removing the previous tether');

      workedExampleTriggerTether.disable();
      $(workedExampleTriggerTether.element).detach();
      workedExampleTriggerTether = null;
    }

    const workedExampleTrigger = toTabPane.find('.js__tabs__next-tab-trigger--fixed-bottom');
    if (workedExampleTrigger.length > 0) {
      // workedExampleTrigger.hide();
      workedExampleTrigger.css('visibility', 'hidden'); // Means it still takes up the space and the floating element doesn't hide the content
      const clonedElement = workedExampleTrigger.clone();
      // clonedElement.show();
      clonedElement.removeAttr('style'); // Get rid of the hide
      $('body').append(clonedElement);
      debug('Attaching worked example end trigger');
      workedExampleTriggerTether = new Tether({
        element: clonedElement,
        target: 'body',
        attachment: 'bottom middle',
        targetAttachment: 'bottom middle',
      });
      workedExampleTriggerTether.position();
    }
  }
  function getTabPaneFromLink(tabLink) {
    const dataTargetRef = $(tabLink).attr('data-target');
    const hrefExtract = /#(.+)/.exec($(tabLink).attr('href'));
    const href = (hrefExtract && hrefExtract.length > 1 ? hrefExtract[1] : null);
    const newTabSelector = ((dataTargetRef || href) ? `#${dataTargetRef || href}` : null);
    // if ($(newTabSelector).hasClass('.js__tabs__tab-pane') == false) console.error('The linked tab pane does not have the js__tabs__tab-pane class', tabLink, $(newTabSelector) );
    return $(newTabSelector);
  }

  function getTabLinkFromRef(ref) {
    const dataTargetRef = $(ref).attr('data-target');
    const hrefExtract = /#(.+)/.exec($(ref).attr('href'));
    const href = (hrefExtract && hrefExtract.length > 1 ? hrefExtract[1] : null);
    const newTabSelector = ((dataTargetRef || href) ? `#${dataTargetRef || href}` : null);
    const usingDataTarget = $(`.js__tabs__tab-link[data-target="${newTabSelector}"]`);
    const usingHref = $(`.js__tabs__tab-link[href*="${newTabSelector}"]`); // SS appends stuff to the href use data-target if it is behaving weird
    return usingDataTarget.length !== 0 ? usingDataTarget : usingHref;
  }

  function searchTabBase(target) {
    const parent = $(target).closest('.js__tabs__parent-container'); // Child tabs
    const searchUp = $(target).closest('.js__tabs');
    const overall = $('.js__tabs');
    let selector;
    if (parent.length > 0) {
      selector = $(parent).find('.js__tabs').first();
    } else if (searchUp.length > 0) {
      selector = searchUp;
    } else if (overall.length > 0) {
      selector = overall;
    } else throw new Error('There is not a .js__tabs on the page');

    return $(selector).first();
  }

  // Ideally we add all functionality here and don't need events
  function beforeTabHidden({ fromTabLink, fromTabPane, toTabLink, toTabPane }) {

  }
  function afterTabHidden({ fromTabLink, fromTabPane, toTabLink, toTabPane }) {

  }
  function beforeTabShown({ fromTabLink, fromTabPane, toTabLink, toTabPane }) {
    // handleNextDefaultTabButton()
    workedExampleBeforeShown(toTabPane);
  }
  function afterTabShown({ fromTabLink, fromTabPane, toTabLink, toTabPane, changingBetweenTabs }) {
    if (changingBetweenTabs) ensureTopOfTabShown(toTabLink, toTabPane);
  }
  function afterInit({ tabLink, tabPane }) {
    workedExampleBeforeShown(tabPane);
  }
  // TODO: 
  // - init behaviour
  // - next tab button
  // - go to tab button that is in the content, can have a reference to js__tabs or just does it by parent

  // NOTE: Default active tab link must have the js__tabs--active class set

  // TODO also need to check the URL and open the last set tab
  function initTabs() {
    $('.js__tabs').each((i, value) => {
      const tabLink = $(value).find('.js__tabs__tab-link.js__tabs--active:first');
      if (tabLink.length == 0) throw new Error('There is no tab link set as active .js__tabs__tab-link.js__tabs--active on', value);
      const tabPane = getTabPaneFromLink(tabLink);
      const tabPanes = tabPane.siblings('.js__tabs__tab-pane');
      const tabLinkContainer = $(tabLink).parent('.js__tabs__tab-link-container');

      tabPanes.hide();
      // Ensure all the classes are added
      $(tabLink).addClass('active');
      $(tabLink).addClass('js__tabs--active');
      $(tabLinkContainer).addClass('active');
      $(tabLinkContainer).addClass('js__tabs--active');
      $(tabPane).addClass('active');
      $(tabPane).addClass('js__tabs--active');
      tabPane.show();

      afterInit({ tabLink, tabPane });
    });
  }

  // On load need to hide all tabs except the first
  $('body').on('click', '.js__tabs__tab-link', (e) => {
    debug("HERE");
    const tabsBase = searchTabBase(e.currentTarget);
    const fromTabLink = tabsBase.find('.js__tabs__tab-link.js__tabs--active').first();
    const fromTabPane = getTabPaneFromLink(fromTabLink);
    const fromTabLinkContainer = fromTabLink.parent('.js__tabs__tab-link-container');

    const toTabLink = $(e.currentTarget);
    const toTabPane = getTabPaneFromLink(toTabLink);
    const toTabLinkContainer = toTabLink.parent('.js__tabs__tab-link-container');

    const changingBetweenTabs = fromTabLink.is(toTabLink) === false;
    beforeTabHidden({ fromTabLink, fromTabPane, toTabLink, toTabPane, changingBetweenTabs });
    // hide the tab, set the active class
    $(fromTabLink).removeClass('active');
    $(fromTabLink).removeClass('js__tabs--active');
    $(fromTabLinkContainer).removeClass('active');
    $(fromTabLinkContainer).removeClass('js__tabs--active');
    $(fromTabPane).removeClass('active');
    $(fromTabPane).removeClass('js__tabs--active');

    $(fromTabPane).hide(); // should be handled in css

    afterTabHidden({ fromTabLink, fromTabPane, toTabLink, toTabPane, changingBetweenTabs });


    beforeTabShown({ fromTabLink, fromTabPane, toTabLink, toTabPane, changingBetweenTabs });
    // Set the active classes and show the tab
    $(toTabLink).addClass('active');
    $(toTabLink).addClass('js__tabs--active');
    $(toTabLinkContainer).addClass('active');
    $(toTabLinkContainer).addClass('js__tabs--active');
    $(toTabPane).addClass('active');
    $(toTabPane).addClass('js__tabs--active');

    $(toTabPane).show(); // should handled in css
    afterTabShown({ fromTabLink, fromTabPane, toTabLink, toTabPane, changingBetweenTabs });
    debug('Finished with the tab link click');
  });

  $('body').on('click', '.js__tabs__to-tab', (e) => {
    debug('Got a click on a js__tabs__to-tab');
    const tabContainer = searchTabBase(e.currentTarget);
    const tabLink = getTabLinkFromRef(e.currentTarget);
    tabLink.click();
  });

  $('[data-target="next-tab"]').click((e) => {
    debug('Got a click on a [data-target="next-tab"]');
    const tabContainer = searchTabBase(e.currentTarget);
    const tabLinks = tabContainer.find('.js__tabs__tab-link');
    const activeTabLink = tabContainer.find('.js__tabs__tab-link.js__tabs--active');
    const activeIndex = tabLinks.index(activeTabLink);
    debug('Current active tab index is ', activeIndex);
    if (tabLinks.length >= activeIndex + 1) tabLinks[activeIndex + 1].click();
  });


  initTabs();
});
// }(jQuery);



// WEBPACK FOOTER //
// Glasshouse/Core/js/tabs.js